import React, { useEffect, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import type { Engine } from "@tsparticles/engine";
import { loadSlim } from "@tsparticles/slim";

const ParticleComponent: React.FC = () => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    const initEngine = async (): Promise<void> => {
      await initParticlesEngine(async (engine: Engine) => {
        await loadSlim(engine);
      });
      setInit(true);
    };

    void initEngine();
  }, []);

  if (!init) {
    return null;
  }

  return (
    <Particles
      data-testid="particles-component"
      id="tsparticles"
      options={{
        fpsLimit: 120,
        fullScreen: {
          enable: true,
          zIndex: 1,
        },

        particles: {
          color: {
            value: "#113facff",
          },
          links: {
            enable: true,
            distance: 150,
            color: "#2159dbff",
            opacity: 0.5,
            width: 1,
          },
          number: {
            value: 80,
            density: {
              enable: true,
            },
          },
          opacity: {
            value: 0.7,
          },
          shape: {
            type: "circle",
          },
          size: {
            value: 3,
          },
          move: {
            enable: true,
            speed: 0.8,
            direction: "none",
            random: false,
            straight: false,
            outModes: {
              default: "out",
            },
          },
        },
        detectRetina: true,
      }}
    />
  );
};

export default ParticleComponent;
